import { PageStatus, TeamDetailsFragment } from '../../../types/__generated__';
import usePageQuery, {
  UsePageQueryResult,
  buildQuery,
} from '../../hooks/usePageQuery';

import IconLabel from '../IconLabel/IconLabel';
import IsPageOwner from '../IsPageOwner/IsPageOwner';
import React from 'react';
import config from '../../client/config';
import gql from 'graphql-tag';
import { teamIcon } from '@justgiving/icons';
import { useTranslation } from 'react-i18next';

const FRAGMENT = buildQuery(gql`
  fragment TeamDetails on Page {
    legacyId
    relationships {
      teams(first: 1) {
        nodes {
          ... on Page {
            id
            legacyId
            title
            url
            status
          }
        }
      }
    }
  }
`);

interface TeamDetailsProps {
  showCreateTeamCTA?: boolean;
}

const TeamDetails: React.FunctionComponent<TeamDetailsProps> = ({
  showCreateTeamCTA = true,
}) => {
  const teamDetails = usePageQuery<TeamDetailsFragment>(FRAGMENT);
  const { t } = useTranslation('common', { useSuspense: false });

  const team = teamDetails.data?.relationships?.teams.nodes[0];

  if (showCreateTeamCTA) {
    if (!UsePageQueryResult.hasData(teamDetails) || !team) {
      return (
        <IsPageOwner>
          <IconLabel
            icon={teamIcon}
            label={
              <a
                href={`${config.baseUri}/teams-creation?frpid=${teamDetails.data?.legacyId}`}
              >
                {t('page.createTeamCta')}
              </a>
            }
          />
        </IsPageOwner>
      );
    }

    if (team.status === PageStatus.Inactive) {
      return (
        <IsPageOwner>
          <IconLabel
            icon={teamIcon}
            label={
              <>
                <a
                  href={`${config.baseUri}/teams-creation/create/${team.legacyId}/team-name`}
                >
                  {t('page.finishTeamCreation')}
                </a>
                <span>: {team.title}</span>
              </>
            }
          />
        </IsPageOwner>
      );
    }
  }

  if (team) {
    return (
      <IconLabel
        icon={teamIcon}
        label={
          <span>
            Team: <a href={team.url}>{team.title}</a>
          </span>
        }
      />
    );
  }

  return null;
};

export default TeamDetails;
